import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Menu } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const navLinkStyle =
  "duration-200 text-sm md:text-lg hover:text-xl hover:text-[#00E0DA] hover:ease-in py-1 mx-6";

const Navbar = () => {
  const [open, setopen] = useState(true);
  const breakpoint = 768;

  useEffect(() => {
    if (window.innerWidth > breakpoint) setopen(true);
    else setopen(false);
    function handleResizeWindow() {
      if (window.innerWidth > breakpoint) setopen(true);
      else setopen(false);
    }
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);
  return (
    <motion.div
      animate={{
        opacity: 1,
        height: open && window.innerWidth < breakpoint ? "100vh" : "auto",
      }}
      transition={{ duration: 2 }}
      initial={{ opacity: 0 }}
      className={`flex flex-col md:flex-row w-full md:justify-between  bg-[#070707eb] fixed items-center px-4 overflow-hidden z-10 w-88.15% mx-auto top-0 opacity-95 shadow-box mb-2 ${
        open ? "h-[100vh]" : ""
      } h-10 border-b-4 border-[#4D4D4D]`}
    >
      <div className="flex flex-row justify-between align-middle">
        {" "}
        <div className="mx-8 flex flex-row">
          <div
            className="md:hidden self-center"
            onClick={() => {
              setopen(!open);
            }}
          >
            {" "}
            <Menu className="min-h-[fit-content]" sx={{ color: "white" }} />
          </div>

          <img
            src="vpack-logo-4.svg"
            alt="Logo"
            className="ml-10 my-1 py-6 object-contain max-w-[100px] md:max-w-[160px]"
          />
        </div>
        <div className={`md:hidden p-2 content-center ${open ? "" : "hidden"}`}>
          <CloseIcon
            onClick={() => {
              setopen(!open);
            }}
            sx={{ color: "white" }}
          />
        </div>
      </div>

      <nav className={`flex self-center ${open ? "" : "hidden"} `}>
        <ul className="flex flex-col md:flex-row font-HNlight tracking-wide text-neutral-300 h-[50vh] md:h-auto justify-center text-base md:text-lg">
          <li className={navLinkStyle}>
            <Link
              to={"/home"}
              onClick={() => {
                if (window.innerWidth < breakpoint) setopen(false);

                window.location.href = "#";
              }}
            >
              {" "}
              HOME
            </Link>
          </li>
          <li className={navLinkStyle}>
            <Link
              to={"/products"}
              onClick={() => {
                if (window.innerWidth < breakpoint) setopen(false);
                window.location.href = "#";
              }}
            >
              PRODUCTS
            </Link>
          </li>
          <li className={navLinkStyle}>
            <Link
              to={"/achievements"}
              onClick={() => {
                if (window.innerWidth < breakpoint) setopen(false);
                window.location.href = "#";
              }}
            >
              ACHIEVEMENTS
            </Link>
          </li>
          <li className={navLinkStyle}>
            <Link
              to={"/aboutus"}
              onClick={() => {
                if (window.innerWidth < breakpoint) setopen(false);
                window.location.href = "#";
              }}
            >
              ABOUT
            </Link>
          </li>
        </ul>
      </nav>
      <Link
        to="/contactus"
        className={`my-1 md:mx-8 ${open ? "" : "hidden"}`}
        onClick={() => {
          if (window.innerWidth < breakpoint) setopen(false);
        }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#004845",
            color: "#0fbcb6",
            borderRadius: 2,
            textAlign: "end",
          }}
        >
          Contact Us
        </Button>
      </Link>
    </motion.div>
  );
};
export default Navbar;
